import { render, staticRenderFns } from "./AccessLogsIndex.vue?vue&type=template&id=58b59db5&scoped=true"
import script from "./AccessLogsIndex.vue?vue&type=script&lang=js"
export * from "./AccessLogsIndex.vue?vue&type=script&lang=js"
import style0 from "./AccessLogsIndex.vue?vue&type=style&index=0&id=58b59db5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b59db5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b59db5')) {
      api.createRecord('58b59db5', component.options)
    } else {
      api.reload('58b59db5', component.options)
    }
    module.hot.accept("./AccessLogsIndex.vue?vue&type=template&id=58b59db5&scoped=true", function () {
      api.rerender('58b59db5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/privacy/AccessLogsIndex.vue"
export default component.exports